import React from "react";
import { Helmet } from "react-helmet";
import Clientelle from "../components/home/Clientelle";
import OurWorks from "../components/home/OurWork";
import PageHero from "../components/reusables/hero/PageHero";
import ServicesBody from "../components/services/ServicesBody";

export default function Services() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.negash.co/services"
        />
        <meta
          name="description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          property="og:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta property="og:title" content="Our Services - Negash Construction Company" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />

        <meta name="twitter:title" content="Our Services - Negash Construction Company" />
        <meta
          name="twitter:text:title"
          content="Our Services - Negash Construction Company"
        />
        <meta
          name="twitter:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />
        <title>Our Services - Negash Construction Company</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase white text-shadow"
        title="Our Services"
      />
      <ServicesBody />
      <Clientelle />
    </>
  );
}
